import HmsEntityFormController from 'components/Form/HmsEntityFormController';
import HmsEntityFormGridBasic from 'components/Form/HmsEntityFormGridBasic';
import HmsField from 'components/Form/HmsField';
import useEntities from 'hooks/useEntities';
import useLoadEntity from 'hooks/useLoadEntity';

const SeasonSpecialRequest = () => {
  const entities = useEntities();
  const entity = entities.SeasonSpecialRequest;
  const parentEntity = entities.Season;
  const { id, parentId, isLoading, isError, isNotFound, data, reload, parentData, childrenData } = useLoadEntity({ entity, parentEntity });

  return (
    <>
      <HmsEntityFormController
        {... {entity, parentEntity, id, parentId, isLoading, isError, isNotFound, data, reload, parentData, childrenData} }
        form={(
          <div className="flex flex-col desktop:flex-row w-full">
            <div className="flex-auto">
              <HmsEntityFormGridBasic>
                <HmsField name="name" autoFocus />
                <HmsField name="label" />
                <HmsField name="icon" />
                <HmsField name="description" />
                <HmsField name="placeholder" />
                {/* <HmsField name="color" /> */}
              </HmsEntityFormGridBasic>
            </div>
          </div>
        )}
      />
    </>
  );
}

export default SeasonSpecialRequest
